import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";
import ProductGridSingleSeven from "../../components/product/ProductGridSingleSeven";
import {
  getPriceByCountry,
  getDiscountByCountry,
} from "../../helpers/countryHelper";

const ProductGridList = ({ products, spaceBottomClass, layout }) => {
  const currency = useSelector((state) => state.currency);
  const { cartItems } = useSelector((state) => state.cart);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { compareItems } = useSelector((state) => state.compare);
  const { selectedCountry } = useSelector((state) => state.country);

  return (
    <Fragment>
      {products?.map((product) => {
        // Get price and discount based on selected country
        const countryPrice = getPriceByCountry(product, selectedCountry);
        const countryDiscount = getDiscountByCountry(product, selectedCountry);

        // Create adjusted product with country-specific prices
        const adjustedProduct = {
          ...product,
          price: countryPrice,
          discount: countryDiscount,
        };

        return (
          <div
            className={`${
              layout == "grid three-column" && "col-lg-4 col-6 p-1"
            } ${layout == "grid two-column" && "col-lg-4 col-6 p-1"} ${
              layout == "list" && "col-6 p-1"
            }`}
            key={product.id}
          >
            <ProductGridSingleSeven
              layout={layout}
              spaceBottomClass={spaceBottomClass}
              product={adjustedProduct}
              currency={currency}
              cartItem={cartItems.find(
                (cartItem) => cartItem.id === product.id
              )}
              wishlistItem={wishlistItems.find(
                (wishlistItem) => wishlistItem.id === product.id
              )}
              compareItem={compareItems.find(
                (compareItem) => compareItem.id === product.id
              )}
            />
          </div>
        );
      })}
    </Fragment>
  );
};

ProductGridList.propTypes = {
  products: PropTypes.array,
  spaceBottomClass: PropTypes.string,
};

export default ProductGridList;
